<template>
  <div class="miniDash">
    <horizontal-bar-chart
      :chart-data="lineChart"
      :options="lineChartOptions"
      :width="200"
      :height="200"
      class="chart"
    >
    </horizontal-bar-chart>
    <div
      class="pontosObtidos"
      v-if="
        isFullAdmin ||
        (config.verPontosObtidos && groupsConfig.verPontosObtidos)
      "
    >
      <div class="title">Pontos Obtidos</div>
      <div class="valor">
        {{ miniDash.length && miniDash[0].pontosObtidos }}
      </div>
    </div>
  </div>
</template>
<script>
import { cityAPI } from "@/modules/city";
import { mapActions, mapGetters } from "vuex";
import HorizontalBarChart from "../../../components/chart/HorizontalBarChart.vue";

export default {
  components: { HorizontalBarChart },
  props: {
    municipioId: { type: Number },
  },
  computed: {
    ...mapGetters(["isFullAdmin"]),
  },
  data() {
    return {
      miniDash: [],
      lineChart: {},
      lineChartOptions: {
        legend: {
          display: true,
          position: "bottom",
          labels: {
            usePointStyle: true,
            pointStyle: "circle",
          },
        },
        plugins: {
          customScale: {
            grace: "20%",
            // grace: 40
          },
        },
        scales: {
          yAxes: [
            {
              ticks: {
                display: false, //this will remove only the label
              },
            },
            // {
            //   gridLines: {
            //     display: true,
            //   },
            //   ticks: {
            //     suggestedMin: 0,
            //   },
            // },
          ],
          xAxes: [
            {
              ticks: {
                callback: function (label) {
                  if (label == null) {
                    return "";
                  }
                  if (label.length > 15) {
                    label = label.substring(0, 15);
                    label += "...";
                  }
                  return label;
                },
              },
              gridLines: {
                display: false,
              },
            },
          ],
        },

        responsive: true,
        maintainAspectRatio: false,
      },
      config: JSON.parse(localStorage.getItem("config")),
      groupsConfig: JSON.parse(localStorage.getItem("groupsConfig")),
    };
  },
  mounted() {
    this.getMiniDash();
  },

  methods: {
    ...mapActions(["setLoading"]),
    fillLineChart(valores) {
      this.lineChart = {
        labels: ["Critérios"],
        datasets: [
          {
            label: "Não Evidenciados       ",
            data: valores.map((item) => item.naoEnviados),
            backgroundColor: "#FFC107",
            borderWidth: 2,
            borderRadius: 10,
            borderSkipped: false,
            datalabels: {
              anchor: "end",
              align: "end",
              clamp: true,
              offset: 2,
            },
          },
          {
            label: "Aguardando envio p/ análise       ",
            data: valores.map(
              (item) => item.evidenciadosAguardandoEnvioAnalise
            ),
            backgroundColor: "#f57d30",
            borderWidth: 2,
            borderRadius: 10,
            borderSkipped: false,
            datalabels: {
              anchor: "end",
              align: "end",
              offset: 2,
            },
          },
          {
            label: "Em Análise       ",
            data: valores.map((item) => item.comEvidenciasAnalise),
            backgroundColor: "#5C8BB9",
            borderWidth: 2,
            borderRadius: 10,
            borderSkipped: false,
            datalabels: {
              anchor: "end",
              align: "end",
              offset: 2,
            },
          },
          {
            label: "Aprovados       ",
            data: valores.map((item) => item.aprovados),
            backgroundColor: "#4CAF50",
            borderWidth: 2,
            borderRadius: 10,
            borderSkipped: false,
            datalabels: {
              anchor: "end",
              align: "end",
              offset: 2,
            },
          },
          {
            label: "Rejeitados",
            data: valores.map((item) => item.comEvidenciasRejeitadas),
            backgroundColor: "#FF5252",
            borderWidth: 2,
            borderRadius: 10,
            borderSkipped: false,
            datalabels: {
              anchor: "end",
              align: "end",
              offset: 2,
            },
          },
        ],
      };
    },
    getMiniDash() {
      cityAPI.getMiniDash(this.municipioId).then(({ data }) => {
        if (data) {
          this.miniDash = data;
          this.fillLineChart(data);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.miniDash {
  display: flex;
  column-gap: 1rem;
  .chart {
    width: calc(100% - 200px);
  }
  .pontosObtidos {
    background: #2e4564;
    color: #fff;
    padding: 10px;
    border-radius: 10px;
    text-align: center;
    margin: 0 auto;
    width: 180px;
    height: 120px;
    margin-top: 1rem;
    .valor {
      font-size: 40px;
    }
  }
}
</style>
